import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const OUTCOME_LABELS = {
  Assigned: 'Assigned',
  NeedsConfirmation: 'Needs confirmation',
  NoMatch: 'No match',
  Failed: 'Failed',
  Skipped: 'Skipped',
};

const BulkResultModal = ({ show, title, result, onHide }) => {
  const items = result?.items || [];
  return (
    <Modal show={show} onHide={onHide} centered size="lg" className="modalDeleteWrapper">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-info">
          {result?.assignedCount ?? 0} of {result?.totalRequested ?? 0} assigned,{' '}
          {result?.remainingUnassignedCount ?? 0} still unassigned.
        </div>
        {items.some((i) => i.outcome === 'NeedsConfirmation') && (
          <div className="alert alert-warning">
            Medium or low confidence matches are not auto-assigned. Open the OCR action on those rows to confirm.
          </div>
        )}
        {items.length > 0 && (
          <div className="main_content_table_history" style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <table className="table tableWide">
              <thead>
                <tr>
                  <th>Tracking Number</th>
                  <th>Outcome</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item.packageId}>
                    <td>{item.trackingNumber}</td>
                    <td>{OUTCOME_LABELS[item.outcome] || item.outcome}</td>
                    <td>{item.message}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

BulkResultModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string,
  result: PropTypes.object,
  onHide: PropTypes.func.isRequired,
};

export default BulkResultModal;
